import qvBind from './qv-bind.js'
import qvCloak from './qv-cloak.js'
import qvFor from './qv-for.js'
import qvHtml from './qv-html.js'
import qvIf from './qv-if.js'
import qvMask from './qv-mask.js'
import qvModel from './qv-model.js'
import qvOn from './qv-on.js'
import qvReference from './qv-reference.js'
import qvShow from './qv-show.js'
import qvText from './qv-text.js'
import qvTransition from './qv-transition.js'

const directives = {
    qvIf,
    qvFor,
    qvShow,
    qvTransition,
    qvBind,
    qvOn,
    qvText,
    qvHtml,
    qvModel,
    qvMask,
    qvReference,
    qvCloak,
}

export const registeredDirectives = Object.values(directives)

export default directives
